<template>
  <div>
    <div
      container
      class="px-4"
      v-for="invoiceBySGL in groupedInvoices"
      :key="invoiceBySGL.subGroupCk"
    >
      <div class="subgroup-header">
        <h1 class="color-green">{{ invoiceBySGL.subGroupName }}</h1>
        <div class="_text-right">
          <h1 class="color-green">
            {{ toDollarFormat(invoiceBySGL.subGroupTotal)}}
          </h1>
          <p class="color-moon mb-0">Subgroup Total</p>
        </div>
      </div>
      <div
        class=" card-invoice elevation-2 mx-0"
        v-for="invoice in invoiceBySGL.subGroupInvoices"
        :key="invoice.invoiceNumber"
      >
        <div class="card-compact">
          <v-checkbox
            v-if="!hideCheckBox"
            class="ma-0"
            v-model="selected"
            :value="invoice"
            tabindex="0"
            hide-details
          ></v-checkbox>
          <div class="color-green">
            <router-link
              class="invoice-icon"
              :to="{
                name: 'invoice-details',
                params: { invoiceNumber: invoice.invoiceNumber }
              }"
              ><app-report-icon class="mr-2" />{{
                invoice.invoiceNumber
              }}</router-link
            >
          </div>
          <div class="color-moon">{{ invoice.displayInvoiceDate }}</div>
          <div class="color-moon">{{ invoice.invoiceDescription }}</div>
          <div class="color-moon text-align-end">
            Amount
            <span class="green--text">{{ invoice.displayInvoiceAmount }}</span>
          </div>
          <div class="color-moon text-align-end">
            Balance
            <span class="color-lips">{{ invoice.displayBalance }}</span>
          </div>
          <div :class="statusStyle(invoice.paymentStatus, invoice.block)">
            {{ invoice.block ? 'BLOCKED' : invoice.paymentStatus }}
          </div>
        </div>
        <transition name="slide-fade">
          <div v-if="showDetailedView" class="card-detail align-center _bt1">
            <div>
              <tr>
                <td class="label">Subgroup</td>
                <td class="value">{{ invoice.subGroup }}</td>
              </tr>
              <tr>
                <td class="label">Invoice</td>
                <td class="value">#{{ invoice.invoiceNumber }}</td>
              </tr>
              <tr>
                <td class="label">Invoice Date</td>
                <td class="value">{{ invoice.invoiceDate }}</td>
              </tr>
              <tr>
                <td class="label">Invoice Type</td>
                <td class="value">{{ invoice.invoiceDescription }}</td>
              </tr>
              <tr>
                <td class="label">Status</td>
                <td class="value">
                  {{ invoice.block ? 'BLOCKED' : invoice.paymentStatus }}
                </td>
              </tr>
            </div>

            <div>
              <tr>
                <td class="label">Amount</td>
                <td class="value">{{ invoice.displayInvoiceAmount }}</td>
              </tr>
              <tr>
                <td class="label">Balance</td>
                <td class="value">{{ invoice.displayBalance }}</td>
              </tr>
              <tr>
                <td class="label">Payment Date</td>
                <td class="value">{{ invoice.paidDate }}</td>
              </tr>
              <tr>
                <td class="label">Paid Amount</td>
                <td class="value">{{ invoice.displayPaidAmount }}</td>
              </tr>
              <tr>
                <td class="label">Adjusted Amount</td>
                <td class="value">{{ invoice.displayAdjustmentAmount }}</td>
              </tr>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>
<script>
  import AppReportIcon from '@atoms/ReportIcon.vue'
  import formattable from '@mixins/formattable'

  export default {
    mixins: [formattable],
    components: {
      AppReportIcon
    },
    props: {
      groupedInvoices: {
        type: Array
      },
      showDetailedView: {
        type: Boolean
      },
      selected: {
        type: Array,
        default: () => []
      },
      hideCheckBox: {
        type: Boolean
      }
    },
    computed: {},
    watch: {
      value: function(newVal) {
        this.$set(this, 'selected', newVal)
      },
      selected() {
        this.$emit('toggleSelection', this.selected)
      }
    },
    methods: {
      statusStyle(paymentStatus, isBlocked) {
        if (paymentStatus === 'PAST DUE' || isBlocked) return 'color-lips'
        else if (paymentStatus === 'PAID') return 'color-leaf'
        else return 'color-moon'
      }
    }
  }
</script>

<style lang="scss" scoped>
.subgroup-header {
  display: flex;
  justify-content: space-between;
  align-items:flex-start;
  h1 {
    font-size: 1.4rem;
  }
}

.card-invoice {
  display: flex;
  flex-direction: column;
  position: relative;
  margin: 10px 40px;
}

.card-compact {
  padding: 10px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  >div {
    flex-grow: 5;
    flex-shrink: 1;
    flex-basis: 0;
    text-align: center;
    padding:0 4px;
      &.text-align-start{
      text-align: start;
    }
    &.text-align-end{
      text-align: end;
    }
    &:first-child {
      text-align: start;
    }
    &:last-child {
      text-align: end;
    }
  }
  >.v-input {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: 0;
  }
}

.invoice-icon {
  svg {
    width: 1.4rem;
    height: 1.4rem;
  }
}

.card-detail {
  text-align: center;
  display: flex;
  align-items: flex-start;
  justify-content: space-around;
  padding: 20px;
  background: white;
}

td.label {
  text-align: right;
  font-weight: bold;
}

td.value {
  text-align: left;
  padding-left: 1em;
}
</style>
